import { raise, } from "@bracket/errant";
import { logger, } from "@bracket/ui/logger";

export const currency = ( value: unknown, accessorArgs?: Record<string, unknown> ): string => {
	try {
		return (
			typeof value === "number" ? value :
			typeof value === "string" ? parseFloat(value) :
			typeof value === "symbol" ? parseFloat(value.toString()) :
			raise("CurrencyAccessor - value must be a number")
		).toLocaleString("en-US", { style: "currency", currency: "USD", });
	}
	catch(error) {
		logger.error(`@bracket/ui Text:CurrencyAccessor - error formatting currency value of type ${typeof value} :: ${error instanceof Error ? error.message : error}`);
		return "N/A";
	}
};
